export default {
    start: {},
    ping: {},
    isStarting: false,
    returnUrl: '',
    loginState: '' // Store state from login-url response
}
